import { Box, Typography } from '@mui/material';
import { ProductInfo } from '../../../types/ResultTypes';

interface ProductDescriptionDetailScreenProps {
  data: ProductInfo;
}

export default function ProductDescriptionDetailScreen(
  props: ProductDescriptionDetailScreenProps
) {
  const { data } = props;
  let featureInfo = data.features?.join('. ');
  return (
    <Box
      height={'0px'}
      display={'flex'}
      gap={'1rem'}
      flexDirection={'column'}
      alignItems={'center'}
    >
      {/* height={'0px'} is a workaround for how the Split component handles height/overflow */}
      <img src={data.imageLink} width={'280rem'} alt={data.name} />
      <Box>
        <Typography
          mr={1}
          display={'inline'}
          variant="h5"
          component="h1"
          gutterBottom
        >
          Name:
        </Typography>
        <Typography display={'inline'} variant="body1">
          {data.name}
        </Typography>
      </Box>
      <Box>
        <Typography
          mr={1}
          display={'inline'}
          variant="h5"
          component="h1"
          gutterBottom
        >
          Description:
        </Typography>
        <Typography display={'inline'} variant="body1">
          {data.description}
        </Typography>
      </Box>
      <Box>
        <Typography
          mr={1}
          display={'inline'}
          variant="h5"
          component="h1"
          gutterBottom
        >
          Dimensions:
        </Typography>
        <Typography display={'inline'} variant="body1">
          {data.dimensions}
        </Typography>
      </Box>
      <Box>
        <Typography
          mr={1}
          display={'inline'}
          variant="h5"
          component="h1"
          gutterBottom
        >
          Color(s):
        </Typography>
        <Typography display={'inline'} variant="body1">
          {data.color}
        </Typography>
      </Box>
      <Box>
        <Typography
          mr={1}
          display={'inline'}
          variant="h5"
          component="h1"
          gutterBottom
        >
          Features:
        </Typography>
        <Typography display={'inline'} variant="body1">
          {' '}
          {featureInfo}
        </Typography>
      </Box>
    </Box>
  );
}
